import React, { FC } from 'react'
import { EmbeddedCoursesContent } from './courses-page'

interface Props {}

const EmbeddedCoursesPage: FC<Props> = ({}) => {
  return (
    <div
      id="exam-solutions-courses-embedded-page"
      className="h-full w-[100%] flex justify-center items-center overflow-y-auto"
    >
      <EmbeddedCoursesContent />
    </div>
  )
}

export default EmbeddedCoursesPage
